import { Component } from 'san';
import { ISchedule, IScheduleTimesCallback } from 'src/models';
import checkOrgUsersService from 'src/services/checkOrgUsers.service';
import scheduleTimesServices from 'src/services/scheduleTimes.services';
import DatePicker from '../DatePicker/DatePicker';

export default class Schedule extends Component {
    constructor(options: any) {
        super(options);
    }

    static components = {
        'ui-date-picker': DatePicker,
    }

    initData(): {
        schedule: ISchedule;
        index: number;
    } {
        return {
            schedule: null,
            index: 0,
        };
    }

    checkUser() {
        checkOrgUsersService.show({
            isMultiple: false,
            callback: (user)=> {
                this.data.set('schedule.schedule_account', user[0].user_id);
                this.data.set('schedule.schedule_account_name', user[0].name);
            }
        });
    }

    toCopy() {
        scheduleTimesServices.show(this.copySchedules);
    }

    copySchedules: IScheduleTimesCallback = (times) => {
        this.fire('copy', {
            schedule: this.data.get('schedule'),
            times
        });
    }

    toDelete() {
        this.fire('delete', this.data.get('index'));
    }
   
}
